export function timeToMs(time: string | undefined) {
    if (!time) return undefined;
    const ms = new Date(`1/1/1970 ${time} GMT`).getTime();
    return isNaN(ms) ? undefined : ms;
}
